import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BankAccount } from '../../../../../banking/models/bank-account';

@Component({
  selector: 'app-vb-payment-change-deposit-detail-change-accordion',
  templateUrl: './vb-payment-change-deposit-detail-change-accordion.component.html',
  styleUrls: ['./vb-payment-change-deposit-detail-change-accordion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbPaymentChangeDepositDetailChangeAccordionComponent {
  @Input({ required: true }) bankAccount!: BankAccount | null;
  @Input() isWrittenCheque = false;

  private _accordionIsExpanded = new BehaviorSubject<boolean>(false);
  public accordionIsExpanded$ = this._accordionIsExpanded as Observable<boolean>;

  public toggleAccordionExpand(): void {
    this.accordionIsExpanded$.once(expanded => {
      this._accordionIsExpanded.next(!expanded);
    });
  }
}
